<template>
  <div class="accordion">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    isExclusiveOpen: {
      type: Boolean,
    },
  },

  created() {
    if (this.isExclusiveOpen) this.$root.$on('accordion-click', this.broadcastPotentialClose)
  },

  methods: {
    broadcastPotentialClose(openIndex) {
      this.$root.$emit('close-accordion-items', openIndex)
    },
  },
}
</script>
